import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';
import { TemplateInvoiceList } from './template/List';

export const Invoice: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain='ap-enhance-invoice-list-search'
      >
        <TemplateInvoiceList />
      </OpenFeatureProvider>
    </Wrapper>
  );
};
